const dateFieldsOrder = ['launchDate', 'finalSelectionDate', 'evaluationStartDate', 'closingDate']
const dateEventFieldsOrder = ['startDate', 'endDate']

export const limitDataFields = (
  selectedDate: string,
  previousDate: string,
  selectedFieldName: string,
  dateRestrictions: any,
  isEvent: boolean = false
): void => {
  const fieldsOrder = isEvent ? dateEventFieldsOrder : dateFieldsOrder
  const selectedFieldKey = fieldsOrder.findIndex((field) => field === selectedFieldName)

  fieldsOrder.forEach((field, fieldKey) => {
    if (fieldKey >= selectedFieldKey) return

    const fieldName = fieldsOrder[fieldKey]

    if (
      selectedDate === '' &&
      dateRestrictions.max[fieldName] !== null &&
      dateRestrictions.max[fieldName].toISOString().split('T')[0] === previousDate
    ) {
      dateRestrictions.max[fieldName] = dateRestrictions.max[selectedFieldName] ?? null
      return
    }

    if (
      dateRestrictions.max[field] === null ||
      dateRestrictions.max[field] === '' ||
      dateRestrictions.max[field] > new Date(`${selectedDate}T00:00`) ||
      dateRestrictions.max[field].toISOString().split('T')[0] === previousDate
    ) {
      dateRestrictions.max[fieldName] = new Date(`${selectedDate}T00:00`)
    }
  })

  fieldsOrder.forEach((field, fieldKey) => {
    if (fieldKey <= selectedFieldKey) return

    const fieldName = fieldsOrder[fieldKey]

    if (
      selectedDate === '' &&
      dateRestrictions.min[fieldName] !== null &&
      dateRestrictions.min[fieldName].toISOString().split('T')[0] === previousDate
    ) {
      dateRestrictions.min[fieldName] = dateRestrictions.min[selectedFieldName] ?? null
      return
    }

    if (
      dateRestrictions.min[field] === null ||
      dateRestrictions.min[field] === '' ||
      dateRestrictions.min[field] < new Date(`${selectedDate}T00:00`) ||
      dateRestrictions.min[field].toISOString().split('T')[0] === previousDate
    ) {
      dateRestrictions.min[fieldName] = new Date(`${selectedDate}T00:00`)
    }
  })
}
